// extracted by mini-css-extract-plugin
var _1 = "Section__Section___UR5K0";
var _2 = "Section__wiggle___s45mV";
export { _1 as "Section", _2 as "wiggle" }
